/* eslint-disable no-undef */
/* eslint-disable no-restricted-globals */
import { addScript, addImagePixel } from '../util'
import { LandingPageNumber, CertificatePageNumber } from '../../constants'

const tags3p_pageReady = dataLayer => {
  const isCertificate = dataLayer.pageInfo.page === CertificatePageNumber
  const isLanding = dataLayer.pageInfo.page === LandingPageNumber
  const experience = dataLayer.pageInfo.experience

  doLuther(dataLayer, isLanding)
  doDoubleClickFloodlight()
  doFacebook(experience)
  doAutoWeb(dataLayer, experience, isCertificate)

  switch (experience) {
    case 'atc':
      doForesee()
      doGoogleRemarket()
      doGoogleGlobal(isCertificate)
      break
    case 'kbb':
      doUniversalPixel()
      doGmcOutcomes(dataLayer, isCertificate)
      doChevyFloodlight(dataLayer, isCertificate)
      break
    default:
  }
}

// Luther
// map Luther Dealer Id to GTM code
const doLuther = (dataLayer, isLanding) => {
  try {
    const GTM_Code = function() {
      const dealerIdMapping = {
        '1328833': 'T8JB9H',
        '66943249': '5R89WK',
        '70530': 'K3XZBJ',
        '63846425': 'M8XT63',
        '100002810': 'PCZFFF',
        '55570252': 'K3LB4N',
        '70799': 'MCRQVZ',
        '63377267': 'TLNPGV',
        '1117808': 'WWJ4GT',
        '67848257': 'MZGXTJ',
        '68314183': 'KVVZ9B',
        '626962': 'TLCG9C',
        '70763': 'M84W85',
        '46389236': 'KS6696',
        '1393602': 'NX9FJT',
        '55334626': 'TVH4TT',
        '1150930': '5H5LJP',
        '740360000': 'TXM6R6',
        '73984': 'KSBP32',
        '100010274': 'MCZTRT',
        '71574': 'WXRHTT',
        '72586': 'P3P53S',
        '70435': 'TXGH6V',
        '65593801': 'MCGMQK',
        '582559': 'WH5T85',
        '831858': '5F89TC',
        '67937427': 'TCKF9Q8'
      }

      const dealerIdParams = dataLayer.offer.dealerid

      if (isLanding) {
        if (dealerIdParams) {
          // For ATC funnel
          _satellite.cookie.set('DTM_DealerId', dealerIdParams)
          return dealerIdMapping[dealerIdParams] || ''
        } else {
          // For those ATC and KBB funnel not belong to Luther dealer
          return ''
        }
      }

      return ''
    }

    const gtmCode = GTM_Code()

    if (gtmCode) {
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({
        event: 'Page View Custom'
      })

      if (addScript(`www.googletagmanager.com/gtm.js?id=GTM-${gtmCode}`)) {
        window.dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' })
      }
    }
  } catch (e) {
    console.log('analytics luther error', e)
  }
}

// ICO Landing Page Assembly DoubleClick Floodlight
const doDoubleClickFloodlight = () => {
  try {
    addDoubleClickImagePixel('8149977.fls.doubleclick.net/activityi;src=8149977;type=allot0;cat=insta0')
  } catch (e) {
    console.log('analytics dbcfl error', e)
  }
}

// Facebook PageView Code
const doFacebook = experience => {
  try {
    if (!window.fbq) {
      const n = (window.fbq = function() {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
      })
      if (!window._fbq) window._fbq = n

      n.push = n
      n.loaded = !0
      n.version = '2.0'
      n.queue = []

      addScript('connect.facebook.net/en_US/fbevents.js')
    }

    switch (experience) {
      case 'atc':
        window.fbq('init', '1088220411210535')
        window.fbq('track', 'PageView')
        break
      default:
    }
  } catch (e) {
    console.log(`analytics ${experience} fb error`, e)
  }
}

// 360i / Hearts and Science DCM
const doHeartsScience = (dataLayer, experience, isCertificate) => {
  try {
    const mapVars = getMapVars(dataLayer)
    const universalTag = experience === 'atc' ? 'at_he00' : 'kbb_h0'
    const viewTag = experience === 'atc' ? 'at_he0' : 'kbb_h00'
    const certTag = experience === 'atc' ? 'at_he000' : 'kbb_h000'

    initGtag('DC-10178839')
    mapVars.send_to = `DC-10178839/unive0/${universalTag}+standard`
    gtag('event', 'conversion', mapVars)
    addDoubleClickImagePixel(`ad.doubleclick.net/ddm/activity/src=10178839;type=unive0;cat=${universalTag}`, mapVars)

    if (isCertificate) {
      mapVars.send_to = `DC-10178839/iconp0/${certTag}+unique`
      gtag('event', 'conversion', mapVars)
      addDoubleClickImagePixel(`ad.doubleclick.net/ddm/activity/src=10178839;type=iconp0;cat=${certTag}`, mapVars)
    } else {
      mapVars.send_to = `DC-10178839/iconp0/${viewTag}+standard`
      gtag('event', 'conversion', mapVars)
      addDoubleClickImagePixel(`ad.doubleclick.net/ddm/activity/src=10178839;type=iconp0;cat=${viewTag}`, mapVars)
    }
  } catch (e) {
    console.log(`analytics ${experience} hearts error`, e)
  }
}

// AutoWeb
const doAutoWeb = (dataLayer, experience, isCertificate) => {
  try {
    if (isCertificate && !dataLayer.offer.isAssigned) {
      switch (experience) {
        case 'atc':
          addImagePixel('evt.awadserver.com/ConversionManager?conversionData=eyJjb252ZXJzaW9uVHlwZSI6IkxlYWQiLCJhZHZlcnRpc2VySUQiOjI3MzJ9')
          break
        case 'kbb':
          addImagePixel('evt.awadserver.com/ConversionManager?conversionData=eyJjb252ZXJzaW9uVHlwZSI6IkxlYWQiLCJhZHZlcnRpc2VySUQiOjI2OTF9')
          break
        default:
      }
    }
  } catch (e) {
    console.log('analytics autoweb error', e)
  }
}

/*** ATC ***/

// AdTechnacity (for Adobe AAM)
const doAdTechnacity = () => {
  try {
    const rand = Math.floor(Math.random() * 1000)
    addImagePixel('p1.zemanta.com/p/571/661/?r=' + rand)
  } catch (e) {
    console.log('analytics zemanta error', e)
  }
}

// Foresee Tag
const doForesee = () => {
  try {
    const testAutomation = _satellite.getVar('testAutomation')
    if (testAutomation === 'true') {
      //DO NOT DISPLAY THE FORESEE SURVEY
    } else {
      // ForeSee Embed Script v2.00
      // DO NOT MODIFY BELOW THIS LINE **************************************
      ;(function(g) {
        var d = document,
          am = d.createElement('script'),
          h = d.head || d.getElementsByTagName('head')[0],
          fsr = 'fsReady',
          aex = {
            src: '//gateway.foresee.com/sites/autotrader/production/gateway.min.js',
            type: 'text/javascript',
            async: 'true',
            'data-vendor': 'fs',
            'data-role': 'gateway'
          }
        for (var attr in aex) {
          am.setAttribute(attr, aex[attr])
        }
        h.appendChild(am)
        g[fsr] = function() {
          var aT = '__' + fsr + '_stk__'
          g[aT] = g[aT] || []
          g[aT].push(arguments)
        }
      })(window)
      // DO NOT MODIFY ABOVE THIS LINE **************************************
    }
  } catch (e) {
    console.log('analytics foresee error', e)
  }
}

// Google Remarketing - RLSA
const doGoogleRemarket = () => {
  try {
    addScript('www.googleadservices.com/pagead/conversion_async.js', document.body)

    const dcJS = document.querySelector('script[src*="www.googleadservices.com/pagead/conversion_async.js"]')
    let done = false

    dcJS.onload = dcJS.onreadystatechange = function() {
      if (!done && (!this.readyState || this.readyState === 'loaded' || this.readyState === 'complete')) {
        done = true
        callback()

        // Handle memory leak in IE
        dcJS.onload = dcJS.onreadystatechange = null
        document.body.removeChild(dcJS)
      }
    }
    function callback() {
      if (done) {
        /* <![CDATA[ */
        window.google_trackConversion({
          google_conversion_id: 1048456240,
          google_custom_params: window.google_tag_params,
          google_remarketing_only: true
        })
        //]]>
      }
    }
  } catch (e) {
    console.log('analytics rlsa error', e)
  }
}

// Google Global - 1007294926
const doGoogleGlobal = isCertificate => {
  try {
    initGtag('AW-1007294926')
    gtag('config', 'AW-997771383')
    gtag('config', 'AW-800465916')
    gtag('config', 'DC-9252973')

    // 3P ATC Google ICO Conversion Search Ads 360 3.25.09
    if (isCertificate) {
      setTimeout(function() {
        gtag('event', 'conversion', { send_to: 'AW-1007294926/m__MCJjo8ncQzrOo4AM' })

        // Search Ads 360 3/25/09
        gtag('event', 'conversion', { allow_custom_scripts: true, send_to: 'DC-9252973/ico5t0/insta0+standard' })
      }, 1500)
    }
  } catch (e) {
    console.log('analytics atcga error', e)
  }
}

// Snapchat
const doSnapchat = (dataLayer, isCertificate, isLanding) => {
  try {
    const currentDate = new Date()
    const allowSnapEnd = new Date('12/31/2021')

    if (currentDate <= allowSnapEnd) {
      if (!window.snaptr) {
        const a = (window.snaptr = function() {
          a.handleRequest ? a.handleRequest.apply(a, arguments) : a.queue.push(arguments)
        })
        a.queue = []
        addScript('sc-static.net/scevent.min.js')
      }

      window.snaptr('init', '9b96bc99-31ff-4314-9a88-0edc6a04bafe', { user_email: '' })
      window.snaptr('track', 'PAGE_VIEW')

      if (isLanding || isCertificate) {
        window.snaptr('track', isCertificate ? 'SIGN_UP' : 'START_TRIAL', {
          currency: 'usd',
          content_ids: dataLayer.offer.offerId,
          content_type: 'vehicle',
          price: dataLayer.offer.offerValue,
          year: dataLayer.vehicle.yearId,
          body_style: dataLayer.vehicle.bodyStyle,
          postal_code: dataLayer.location.zip,
          model: dataLayer.vehicle.modelName,
          make: dataLayer.vehicle.makeName,
          exterior_color: dataLayer.vehicle.color,
          drivetrain: dataLayer.vehicle.drivetrain,
          transmission: dataLayer.vehicle.transmission,
          country: 'United States',
          vin: dataLayer.vehicle.vin,
          dealer_id: dataLayer.offer.dealerId
        })
      }
    }
  } catch (e) {
    console.log('analytics snap error', e)
  }
}

// Pinterest
const doPinterest = isCertificate => {
  try {
    const currentDate = new Date()
    const allowPinterestEnd = new Date('12/31/2021')

    if (currentDate <= allowPinterestEnd) {
      if (!window.pintrk) {
        window.pintrk = function() {
          window.pintrk.queue.push(Array.prototype.slice.call(arguments))
        }
        const n = window.pintrk
        n.queue = []
        n.version = '3.0'
        addScript('s.pinimg.com/ct/core.js')
      }

      window.pintrk('load', '2612768950408', { em: '' })
      window.pintrk('page')
      window.pintrk('track', 'pagevisit')
      addImagePixel('ct.pinterest.com/v3/?event=init&tid=2612768950408&pd[em]=&noscript=1')

      if (isCertificate) {
        window.pintrk('track', 'signup')
      }
    }
  } catch (e) {
    console.log('analytics pinterest error', e)
  }
}

/*** KBB ***/

// TTD Universal Pixel
const doUniversalPixel = () => {
  try {
    if (typeof TTDUniversalPixelApi !== 'function') {
      const wrapperDiv = document.createElement('div')

      wrapperDiv.setAttribute('id', 'ttdUniversalPixelTag7bb212390817457398af3a7068102b4c')
      wrapperDiv.setAttribute('style', 'display:none')

      const nearco = document.createElement('script')

      nearco.onload = function() {
        const universalPixelApi = new TTDUniversalPixelApi()
        universalPixelApi.init('78zxs4n', ['v97oazm'], 'https://insight.adsrvr.org/track/up', 'ttdUniversalPixelTag7bb212390817457398af3a7068102b4c')
      }

      nearco.setAttribute('type', 'text/javascript')
      nearco.setAttribute('src', 'https://js.adsrvr.org/up_loader.1.1.0.js')

      wrapperDiv.appendChild(nearco)
      document.body.appendChild(wrapperDiv)
    }
  } catch (e) {
    console.log('analytics ttd error', e)
  }
}

// GMC Outcomes - KBB
const doGmcOutcomes = (dataLayer, isCertificate) => {
  try {
    if (isCertificate && dataLayer.vehicle.makeName === 'GMC' && (dataLayer.vehicle.modelName.indexOf('Sierra') > -1 || dataLayer.vehicle.modelName.indexOf('Yukon') > -1)) {
      const vYear = dataLayer.vehicle.yearId.toString()
      const vName = dataLayer.vehicle.makeName + ' ' + dataLayer.vehicle.modelName
      const vTrim = dataLayer.vehicle.trimName

      initGtag('DC-3924647')
      gtag('event', 'conversion', {
        allow_custom_scripts: true,
        u19: 'ONR',
        u3: vYear,
        u4: vName,
        u5: vTrim,
        send_to: 'DC-3924647/gmckbb/usgmc017+standard'
      })

      addDoubleClickImagePixel(`ad.doubleclick.net/ddm/activity/src=3924647;type=gmckbb;cat=usgmc017;u3=${vYear};u4=${vName};u5=${vTrim};u19=ONR`)
    }
  } catch (e) {
    console.log('analytics gmc error', e)
  }
}

// Chevy Floodlight
const doChevyFloodlight = (dataLayer, isCertificate) => {
  try {
    const currentDate = new Date()
    const allowChevyEnd = new Date('12/31/2022')

    if (
      isCertificate &&
      dataLayer.vehicle.makeName === 'Chevrolet' &&
      currentDate <= allowChevyEnd &&
      (dataLayer.vehicle.modelName.indexOf('Bolt EUV') > -1 || dataLayer.vehicle.modelName.indexOf('Silverado') > -1 || dataLayer.vehicle.modelName.indexOf('Equinox') > -1)
    ) {
      const vYear = dataLayer.vehicle.yearId.toString()
      const vName = dataLayer.vehicle.makeName + ' ' + dataLayer.vehicle.modelName
      const vTrim = dataLayer.vehicle.trimName

      // create script
      initGtag('DC-3924042')
      gtag('event', 'conversion', {
        allow_custom_scripts: true,
        u19: 'ONR',
        u20: 'NRF',
        u3: vYear,
        u4: vName,
        u5: vTrim,
        send_to: 'DC-3924042/chevr0/usche07p+standard'
      })

      addDoubleClickImagePixel(`ad.doubleclick.net/ddm/activity/src=3924042;type=chevr0;cat=usche07p;u3=${vYear};u4=${vName};u5=${vTrim};u19=ONR;u20=NRF`)
    }
  } catch (e) {
    console.log('analytics chevy error', e)
  }
}

const getMapVars = dataLayer => {
  return {
    allow_custom_scripts: true,
    u1: dataLayer.offer.offerState ? dataLayer.offer.offerState : '', // Any Lead Form?   //      'u1': '[TransactionConfirmNumber]',
    u2: dataLayer.location.zip ? dataLayer.location.zip : '', //'u2': '[ZipCode]',
    u3: dataLayer.offer.offerValue ? dataLayer.offer.offerValue.toString() : '', //'u3': '[OfferResult]',
    u4: dataLayer.pageInfo.sectionName ? dataLayer.pageInfo.sectionName : '', // 'u4': '[section]',
    u5: dataLayer.pageInfo.superSectionName ? dataLayer.pageInfo.superSectionName : '', // 'u5': '[sub-section]',
    u6: dataLayer.pageInfo.pageName ? dataLayer.pageInfo.pageName : '', //'u6': '[page name]',
    u7: dataLayer.cookies.psid ? dataLayer.cookies.psid : '', //'u7': '[PSID (Omniture)]',
    u8: dataLayer.vehicle.id ? dataLayer.vehicle.id.toString() : '', //'u8': '[Vehicle ID]',
    u9: dataLayer.vehicle.bodyStyle ? dataLayer.vehicle.bodyStyle : '', // 'u9': '[Style]',
    u10: '', //'u10': '[Trim]',
    u11: dataLayer.vehicle.yearId.toString() ? dataLayer.vehicle.yearId : '', //'u11': '[Year]',
    u12: dataLayer.vehicle.makeName ? dataLayer.vehicle.makeName : '', //'u12': '[Make]',
    u13: dataLayer.vehicle.modelName ? dataLayer.vehicle.modelName : '', //'u13': '[Model]',
    u14: '', //'u14': '[Price]',
    u15: 'used', //'u15': '[New\/Used]',
    u16: '', //'u16': '[Manual\/Auto]',
    u17: '', //'u17': '[Electric\/Hybrid\/Gasoline]',
    u18: '', //'u18': '[EPA Efficiency]',
    u19: document.URL, //'u19': '[ICO URL]',
    u20: dataLayer.offer.offerId ? dataLayer.offer.offerId : '' //'u20': '[ICO Offer ID]',
  }
}

const initGtag = tagId => {
  const scriptExists = document.querySelector('script[src*="www.googletagmanager.com/gtm.js?id=' + tagId + '"]')

  if (!scriptExists) {
    addScript('www.googletagmanager.com/gtag/js?id=' + tagId)

    window.dataLayer = window.dataLayer || []

    window.dataLayer.push('js', new Date())
    window.dataLayer.push('config', tagId)
  }
}

const gtag = () => {
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push(arguments)
}

const addDoubleClickImagePixel = (srcRoot, mapVars) => {
  const axel = Math.random()
  const orderNumber = String(Math.ceil(axel * 10000000000000))
  let srcLink = srcRoot

  if (mapVars) {
    srcLink = `${srcLink};u1=${mapVars.u1};u2=${mapVars.u2};u3=${mapVars.u3};u4=${mapVars.u4};u5=${mapVars.u5};u6=${mapVars.u6};u7=${mapVars.u7};u8=${mapVars.u8};u9=${mapVars.u9};u10=${mapVars.u10};u11=${mapVars.u11};u12=${mapVars.u12};u13=${mapVars.u13};u14=${mapVars.u14};u15=${mapVars.u15};u16=${mapVars.u16};u17=${mapVars.u17};u18=${mapVars.u18};u19=${mapVars.u19};u20=${mapVars.u20}`
  }

  srcLink = `${srcLink};dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;npa=;gdpr=\${GDPR};gdpr_consent=\${GDPR_CONSENT_755};ord=${orderNumber}?`

  addImagePixel(srcLink)
}

export { tags3p_pageReady }
